<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container " style="margin-top:88px">
      <p>&zwnj;</p>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item">
            <router-link to="/Products/Page=1">
              <span class="text-primary">
                Products
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">Products Search Results</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <div class="PcDevice">
        <div class="d-flex justify-content-between">
          <div class="title_fontStyle  h2"><i class="fas fa-caret-right"></i> Products Search Results</div>
          <div class="btn btn-primary d-flex justify-content-center align-items-center" @click="OpenModal">
            <i class="fas fa-search mr-2" style="color:white"></i>Advanced Search
          </div>
        </div>
      </div>

      <div class="MbDevice">
        <div class="title_fontStyle  h3 mb-4"><i class="fas fa-caret-right"></i> Products Search Results</div>
        <div class="btn btn-primary " @click="OpenModal">
          <i class="fas fa-search mr-2" style="color:white"></i>Advanced Search
        </div>
      </div>
      <p>&zwnj;</p>

      <div v-if="hasResult">
        <div class="row ">
          <div class="col-lg-3 mt-4" v-for="item in GetAdvanceSearchPro">
            <div class="text-center bg-white pointer  border card-effect" @click.prevent="goProDetial(item.ProNo)">
              <div class="logImgFrame my-2">
                <img :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.ProImg}`" width="75%" alt="" />
              </div>
              <div class="ProNameFrame px-2">
                <div style="height:50px; font-size:15px; font-weight:bold">
                  <div class="ellipsis_pro">
                    {{ item.ProName }}
                  </div>
                </div>
                <div class="mb-2" style="height:33px">
                  <p class="text-muted ellipsis_exh" style="font-size:12px">{{ item.ComName }}</p>
                </div>
              </div>

              <div class="row border-top mx-0 py-1">
                <div class="col-5 pl-4 iconOpenHover">
                  <span
                    v-show="item.Fav == 1"
                    @click.stop="ClickFav(item.ProNo)"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Remove from favorites "
                  >
                    <img class=" iconOpenHover" src="../../assets/images/liked.png" width="18px" alt="" />
                    <span style="font-size:14px">
                      {{ item.FavCount }}
                    </span>
                  </span>
                  <span
                    v-show="item.Fav == 0"
                    @click.stop="ClickFav(item.ProNo)"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Add to favorites"
                  >
                    <img class="iconOpenHover" src="../../assets/images/like.png" width="18px" alt="" />
                    <span style="font-size:14px">
                      {{ item.FavCount }}
                    </span>
                  </span>
                </div>

                <div class="col-2">
                  <div class="d-flex ">
                    <div class="rightline"></div>
                  </div>
                </div>

                <div class="col-5" @click.stop="OpenAllProModal(item.RegNo, item.ComName)">
                  <span class="d-flex justify-content-center pr-4 iconOpenHover">
                    <div data-toggle="tooltip" data-placement="bottom" title="Show All Product">
                      <i class="fas fa-eye" style="font-size:19px ;margin-top:2px"></i>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- PC版分頁 -->
        <p>&zwnj;</p>
        <p>&zwnj;</p>

        <div class="PcDevice">
          <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
            <nav>
              <ul class="pagination pointer">
                <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                  <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                  </span>
                </li>
                <li class="page-item" :class="{ disabled: currentPage == 1 }">
                  <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                    <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                  </span>
                </li>
                <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                  <span class="page-link" @click="getPage(page)">{{ page }}</span>
                </li>

                <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                  <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                  </span>
                </li>
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                >
                  <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                  </span>
                </li>
              </ul>
              <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
              <p>&zwnj;</p>
            </nav>
          </div>
        </div>

        <div class="MbDevice">
          <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
            <div v-if="currentPage > 10">
              <nav>
                <ul class="pagination pagination-lg pointer">
                  <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                    <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                    </span>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage == 1 }">
                    <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                      <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                    </span>
                  </li>
                  <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                    <span class="page-link" @click="getPage(page)">{{ page }}</span>
                  </li>

                  <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                    <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                    </span>
                  </li>
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                  >
                    <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                    </span>
                  </li>
                </ul>
                <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
              </nav>
            </div>

            <div v-else>
              <nav>
                <ul class="pagination pagination-sm pointer">
                  <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                    <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                    </span>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage == 1 }">
                    <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                      <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                    </span>
                  </li>
                  <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                    <span class="page-link" @click="getPage(page)">{{ page }}</span>
                  </li>

                  <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                    <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                    </span>
                  </li>
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                  >
                    <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                    </span>
                  </li>
                </ul>
                <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
                <p>&zwnj;</p>
              </nav>
            </div>
          </div>
        </div>

        <p>&zwnj;</p>
        <p>&zwnj;</p>
      </div>
      <div v-else>
        <p>&zwnj;</p>
        <div class="d-flex align-items-center mt-2">
          <div class="mb-3">
            <img src="../../assets/images/Noresult3.png" width="55px" alt="" />
          </div>
          <div class="ml-3">
            <p style="font-size:26px">
              No Result Found
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 進階搜尋彈跳視窗  -->

    <div
      class="modal fade"
      id="SearchModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h2 class="modal-title" id="exampleModalLongTitle">
              <img src="../../assets/images/productSearch_icon.png" width="38px" class="mr-1 mb-1" alt="" />
              Advanced Product Search
            </h2>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body m-2">
            <label for="exampleInputEmail1" class="h4 mb-3">
              Keyword
            </label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Enter Keyword"
                v-model="TemplateOptionKeyword"
                @keyup.enter="AdvanceSearch()"
              />
              <div class="input-group-append">
                <button
                  class="input-group-text bg-light"
                  type="button"
                  id="exampleInputEmail1"
                  @click="AdvanceSearch()"
                >
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>
            <div class="d-flex mt-4 mb-2 align-items-center">
              <h4 class="mt-1">Product Categories</h4>
              <div class="btn btn-outline-primary ml-3" style="font-size:14px" @click.prevent="proSettingAll">
                Select All
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 my-1" v-for="item in proInterestList">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    name="checkAll"
                    class="custom-control-input"
                    :value="item.CatNo"
                    :id="item.CatNo"
                    v-model="optionPro"
                  />
                  <label class="custom-control-label" :for="item.CatNo">{{ item.CatName }}</label>
                </div>
              </div>
            </div>

            <div class="d-flex mt-4 mb-2 align-items-center">
              <h4 class="mt-1">Countries/Regions</h4>
              <div class="btn btn-outline-primary ml-3" style="font-size:14px" @click.prevent="CountrySettingAll">
                Select All
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3 my-1" v-for="item in CountryList">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    name="checkAll"
                    class="custom-control-input"
                    :id="item.CountryCode"
                    :value="item.CountryCode"
                    v-model="optionCountry"
                  />
                  <label class="custom-control-label" :for="item.CountryCode">{{ item.Country }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer " style="display:inline">
            <div class="d-flex ">
              <button type="button" class="btn btn-primary" @click.prevent="AdvanceSearch()">Search</button>
              <div class="btn btn-outline-primary ml-2" @click.prevent="delSettingAll">Reset</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 產品資訊 -->

    <div
      class="modal fade"
      id="openProductModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <img src="../../assets/images/product_list_icon.png" width="45px" class="mr-3" alt="" />
            <h3 class="title_fontStyle mt-2">{{ ModalComName }}</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body my-2">
            <loading :active.sync="isLoading" background-color="#D0D0D0	">
              <div class="loadingio-spinner-eclipse-y24d302hfm">
                <div class="ldio-f9ujl5oazv5">
                  <div></div>
                </div>
              </div>
            </loading>
            <div class="row">
              <div class="col-lg-4 my-3" v-for="item in GetExhAllPro">
                <div
                  class="text-center bg-white pointer p-2 border card-effect"
                  @click.prevent="goProDetail(item.ProNo)"
                >
                  <div class="logImgFrame_product">
                    <img
                      :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.ProImg}`"
                      width="60%"
                      alt=""
                    />
                  </div>
                  <div class="ProNameFrame mt-1">
                    <div style="height:50px; font-size:16px; font-weight:bold">
                      <div class="ellipsis_pro">
                        {{ item.ProName }}
                      </div>
                    </div>
                    <div class="mb-2" style="height:30px">
                      <p class="text-muted ellipsis_exh" style="font-size:12px">{{ item.ComName }}</p>
                    </div>
                  </div>

                  <span
                    v-show="item.Fav == 1"
                    @click.stop="ClickFav(item.ProNo)"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Remove from favorites "
                  >
                    <img class=" iconOpenHover" src="../../assets/images/liked.png" width="20px" alt="" />
                    <span style="font-size:14px">
                      {{ item.FavCount }}
                    </span>
                  </span>
                  <span
                    v-show="item.Fav == 0"
                    @click.stop="ClickFav(item.ProNo)"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Add to favorites"
                  >
                    <img class="iconOpenHover" src="../../assets/images/like.png" width="20px" alt="" />
                    <span style="font-size:14px">
                      {{ item.FavCount }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        CSRF_Token: '',
        SearchExhibList: [],
        proInterestList: [],
        CountryList: [],

        GetAdvanceSearchPro: [],

        optionPro: [],
        Optioncountry: [],
        KeywordContent: '',

        s_optionPro: '',
        s_optionCountry: '',
        optionCountry: [],

        currentPage: 2,
        totalPage: '',
        totalNo: '',
        ProductRawData: [],
        totaltenPageNum: 0,
        tenPageNum: 0,
        showpage: [],
        hasResult: true,

        categoryAll: [],
        countryAll: [],

        TemplateOptionKeyword: '',

        ModalComName: '',
        ClickRegNo: '',
        GetExhAllPro: '',
      }
    },

    computed: {
      ...mapGetters([
        'ListStatus',
        'OptionKeyword',
        'Searchcountry',
        'Searchpro',
        'Roomvisible',
        'ShowRoom',
        'exhcode',
      ]),
    },

    watch: {
      optionPro: function(newValue) {
        this.s_optionPro = newValue.toString()
      },

      optionCountry: function(newValue) {
        this.s_optionCountry = newValue.toString()
      },

      $route(to, from) {
        this.reloadResult()
      },
    },

    methods: {
      OpenModal() {
        $('#SearchModal').modal('show')
      },

      proSettingAll() {
        const vm = this
        vm.optionPro = vm.categoryAll
      },

      CountrySettingAll() {
        const vm = this
        vm.optionCountry = vm.countryAll
      },

      delSettingAll() {
        const vm = this

        vm.optionPro = []
        vm.optionCountry = []
        vm.TemplateOptionKeyword = ''
      },

      //點喜愛產品
      ClickFav(no) {
        const vm = this
        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/FavoritesProducts/${vm.exhcode}/${no}`
        const info = {
          CSRF: vm.CSRF_Token,
        }

        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            vm.reGetModalProList()
            vm.$bus.$emit('message:push', 'Added to favorites', 'warning')
          } else if (response.data == '252') {
            window.location.replace(`https://www.chanchao.com.tw/en/`)
          } else if (response.data == '251') {
            vm.alertText = 'Server is busy, please try again later.'

            vm.alertError()
          } else if (response.data == '253') {
            vm.reGetModalProList()
            vm.$bus.$emit('message:push', 'Removed from favorites', 'danger')
          }
        })
      },

      OpenAllProModal(RegNo, ComName) {
        const vm = this
        vm.$store.dispatch('updateLoading', true)

        vm.ModalComName = ComName
        vm.ClickRegNo = RegNo

        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/Products/${vm.exhcode}?Regno=${vm.ClickRegNo}&CatNo=${vm.Searchpro}&countrycode=${vm.Searchcountry}&keyword=${vm.TemplateOptionKeyword}&Type=Exhibitor&mode=more&Page=&Lang=en`
          )
          .then((response) => {
            vm.GetExhAllPro = response.data.Products
            vm.$store.dispatch('updateLoading', false)
            $('#openProductModal').modal('show')
          })
      },

      goProDetail(id) {
        window.open(`https://www.chanchao.com.tw/touchtaiwan/onlineexpo/ProductDetail/${id}`)
      },

      AdvanceSearch() {
        const vm = this

        this.$store.dispatch('Savekeyword', vm.TemplateOptionKeyword)
        this.$store.dispatch('SaveOptionPro', vm.s_optionPro)
        this.$store.dispatch('SaveOptionCountry', vm.s_optionCountry)

        vm.GetAdvancePro()
      },

      GetAdvancePro() {
        const vm = this

        vm.$store.dispatch('updateLoading', true)

        vm.currentPage = 1

        //取得過濾後的參展商列表

        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/Products/${vm.exhcode}?Regno=${vm.ClickRegNo}&CatNo=${vm.Searchpro}&countrycode=${vm.Searchcountry}&keyword=${vm.TemplateOptionKeyword}&Type=null&mode=page&Page=1&Lang=en`
          )
          .then((response) => {
            if (response.data.PageTotal > 0) {
              vm.hasResult = true

              vm.GetAdvanceSearchPro = response.data.Products
              vm.totalPage = response.data.PageTotal
              vm.ProductRawData = []

              for (let i = 0; i < vm.totalPage; i++) {
                if (i % 10 === 0) {
                  vm.ProductRawData.push([])
                }

                const page = parseInt(i / 10)
                vm.ProductRawData[page].push(i + 1)
              }

              vm.totaltenPageNum = vm.ProductRawData.length

              let anaNowPage = vm.currentPage - 1

              vm.tenPageNum = parseInt(anaNowPage / 10)
              vm.showpage = vm.ProductRawData[vm.tenPageNum]

              $('#SearchModal').modal('hide')

              this.$router.push(`/AdvanceSearchProducts/Page=${vm.currentPage}`)

              vm.$store.dispatch('updateLoading', false)
            } else {
              vm.$store.dispatch('updateLoading', false)
              vm.hasResult = false
              alert('No result !')
              $('#SearchModal').modal('hide')
            }
          })
      },

      alertError() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          allowEnterKey: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      reGetModalProList() {
        const vm = this

        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/Products/${vm.exhcode}?Regno=${vm.ClickRegNo}&CatNo=${vm.Searchpro}&countrycode=${vm.Searchcountry}&keyword=${vm.TemplateOptionKeyword}&Type=Exhibitor&mode=more&Page=&Lang=en`
          )
          .then((response) => {
            vm.GetExhAllPro = response.data.Products
            vm.reloadResult()
          })
      },

      optionSearchAll() {
        const vm = this
        this.$store.dispatch('Savekeyword', '')
        this.$store.dispatch('SaveOptionPro', '')
        this.$store.dispatch('SaveOptionCountry', '')
        vm.GetAdvancePro()
      },

      goProDetial(id) {
        this.$router.push(`/ProductDetail/${id}`)
      },

      //分頁

      getPage(page) {
        const vm = this
        vm.currentPage = page
        vm.$router.push({ path: `/AdvanceSearchProducts/Page=${vm.currentPage}` })
        $('html, body').scrollTop(0)

        vm.reloadResult()
      },

      nextPage() {
        const vm = this
        let nextP = Number(vm.currentPage) + 1
        vm.currentPage = nextP

        if (vm.currentPage % 10 == 1) {
          vm.tenPageNum = vm.tenPageNum + 1
          vm.showpage = vm.ProductRawData[vm.tenPageNum]
          vm.currentPage = vm.showpage[0]
        }

        vm.$router.push({ path: `/AdvanceSearchProducts/Page=${vm.currentPage}` })
        $('html, body').scrollTop(0)

        vm.reloadResult()
      },

      lastPage() {
        const vm = this
        let lastP = Number(vm.currentPage) - 1
        vm.currentPage = lastP

        if (vm.currentPage % 10 == 0) {
          vm.tenPageNum = vm.tenPageNum - 1
          vm.showpage = vm.ProductRawData[vm.tenPageNum]
          vm.currentPage = vm.showpage[9]
        }

        vm.$router.push({ path: `/AdvanceSearchProducts/Page=${vm.currentPage}` })
        $('html, body').scrollTop(0)

        vm.reloadResult()
      },

      nexttenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum + 1
        vm.showpage = vm.ProductRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        vm.$router.push({ path: `/AdvanceSearchProducts/Page=${vm.currentPage}` })
        $('html, body').scrollTop(0)

        vm.reloadResult()
      },

      returntenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum - 1
        vm.showpage = vm.ProductRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        vm.$router.push({ path: `/AdvanceSearchProducts/Page=${vm.currentPage}` })
        $('html, body').scrollTop(0)

        vm.reloadResult()
      },

      reloadResult() {
        const vm = this

        vm.$store.dispatch('updateList', false)

        vm.$store.dispatch('updateLoading', true)

        //取得過濾後的參展商列表

        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/Products/${vm.exhcode}?Regno=&CatNo=${vm.Searchpro}&countrycode=${vm.Searchcountry}&keyword=${vm.OptionKeyword}&Type=null&mode=page&Page=${vm.currentPage}&Lang=en`
          )
          .then((response) => {
            vm.GetAdvanceSearchPro = response.data.Products

            vm.$store.dispatch('updateLoading', false)
          })

        //紀錄瀏覽

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      },
    },
    created() {
      $('.modal').modal('hide')
      const vm = this
      this.$store.dispatch('ShowChatRoom', false)
      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      //將vuex的資料匯出去變數裡

      vm.optionPro = vm.Searchpro.split(',')
      vm.optionCountry = vm.Searchcountry.split(',')

      vm.currentPage = vm.$route.params.SearchProPage

      vm.TemplateOptionKeyword = vm.OptionKeyword //將vuex取得的搜尋字放到v-model裡面

      vm.$store.dispatch('updateLoading', true)

      //取得過濾後的產品列表

      vm.$http
        .get(
          `https://www.chanchao.com.tw/apiOnlineExpo/v1/Products/${vm.exhcode}?Regno=&CatNo=${vm.Searchpro}&countrycode=${vm.Searchcountry}&keyword=${vm.OptionKeyword}&Type=null&mode=page&Page=${vm.currentPage}&Lang=en`
        )
        .then((response) => {
          vm.totalNo = response.data.DataTotal
          vm.$store.dispatch('updateLoading', true)

          if (response.data.PageTotal > 0) {
            vm.hasResult = true

            vm.GetAdvanceSearchPro = response.data.Products
            vm.totalPage = response.data.PageTotal

            for (let i = 0; i < vm.totalPage; i++) {
              if (i % 10 === 0) {
                vm.ProductRawData.push([])
              }

              const page = parseInt(i / 10)
              vm.ProductRawData[page].push(i + 1)
            }

            vm.totaltenPageNum = vm.ProductRawData.length

            let anaNowPage = vm.currentPage - 1

            vm.tenPageNum = parseInt(anaNowPage / 10)
            vm.showpage = vm.ProductRawData[vm.tenPageNum]

            vm.$store.dispatch('updateLoading', false)
          } else {
            alert('No result !')
            vm.hasResult = false

            vm.$store.dispatch('updateLoading', false)
          }
        })

      //取得感興趣產品選項
      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/ProductCategories/${vm.exhcode}?Type=&Lang=en`)
        .then((response) => {
          vm.proInterestList = response.data
          vm.proInterestList.forEach((item) => {
            vm.categoryAll.push(item.CatNo)
          })
        })

      //取得國家列表
      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorCountries/${vm.exhcode}?Lang=en`)
        .then((response) => {
          vm.CountryList = response.data
          vm.CountryList.forEach((item) => {
            vm.countryAll.push(item.CountryCode)
          })
        })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  .ellipsis_pro {
    font-size: 15px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .ellipsis_exh {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .logImgFrame {
    width: 200px;
    min-height: 160px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .iconOpenHover {
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
    }
  }

  .rightline {
    border-right: 1px solid #cacacb;
    height: 26px;
  }
</style>
